import { ArcadePage, type ArcadeSpec } from "./ArcadeShell";
import { tk } from "../../../../lib/i18n";

const SPEC: ArcadeSpec = {
  id: "terbang", title: tk("Terbang Kuiz"), tone: "from-cyan-500 to-blue-600", emoji: "🪂", w: 360, h: 520, mascot: true,
  intro: tk("Terbang dengan beg jet bersama Harraz atau Hannah! Terbang melalui gelang dengan jawapan betul dan kutip bintang."),
  load: async () => (await import("./engines/terbang3d")).createTerbang3d,
};
export const TerbangKuizPage = () => <ArcadePage spec={SPEC} />;
